import React, {useEffect, useState} from 'react'
import {useLocation} from "react-router-dom";
import api from "../../api";
import {useTranslations} from "../../lang";
import YouTubeVideo from "../YouTubeVideo";

export default function HelpVideoLoader() {
    const [videoId, setVideoId] = useState(null);
    const location = useLocation();
    const {language} = useTranslations();

    useEffect(() => {
        setVideoId(null);

        api.getHelpVideoForPage(location.pathname, language)
            .then((response) => {
                if (response && response.youtube_video_id) {
                    setVideoId(response.youtube_video_id);
                }
            })
            .catch((error) => {
                console.error("Failed to fetch help video:", error);
            });
    }, [location.pathname, language]);

    if (!videoId) {
        return null;
    }

    return <YouTubeVideo videoId={videoId} />;
}
